import { render, staticRenderFns } from "./HomeProducts.vue?vue&type=template&id=1daebcf8&scoped=true"
import script from "./HomeProducts.vue?vue&type=script&lang=js"
export * from "./HomeProducts.vue?vue&type=script&lang=js"
import style0 from "./HomeProducts.vue?vue&type=style&index=0&id=1daebcf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daebcf8",
  null
  
)

export default component.exports
import {QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QImg})
